'use strict';


import PseudoHintElement from './classes/PseudoHintElement';
import {
  getPosition,
  getSize
} from './lang';


export default {
  /**
   * @see http://vuejs.org/api/options.html#replace
   */
  replace: false,
  /**
   * 
   */
  props: {
    transition: {
      type: String,
      default: ''
    }
  },
  /**
   * @see http://vuejs.org/api/options.html#methods
   */
  methods: {
    /**
     *
     */
    render() {
      let {frontSvgElements, pseudoHintElements, paper} = this.$parent;
      let {$index} = this._scope;
      let groupSvgElement = frontSvgElements[$index];

      if (!groupSvgElement) return;

      let svgElement = groupSvgElement[0][0];
      let {top,left,bottom,right} = getPosition(svgElement);

      let width = right - left;
      let height = bottom - top;

      left += width / 2;
      top += height / 2;

      let element = this.$el;

      left -= element.offsetWidth / 2;
      top -= element.offsetHeight / 2;

      let {width:paperWidth,height:paperHeight} = getSize(paper.canvas);

      let leftInPercents = 100 * left / paperWidth;
      let topInPercents = 100 * top / paperHeight;

      let {style} = element;
      style.left = `${leftInPercents}%`;
      style.top = `${topInPercents}%`;

      element.onmouseenter = () => groupSvgElement.trigger('mouseover');
      element.onmouseleave = () => groupSvgElement.trigger('mouseout');
      element.onclick = () => groupSvgElement.trigger('click');
      
      let {transition} = this;
      let pseudoHintElement = new PseudoHintElement(element, transition);
      pseudoHintElements.push(pseudoHintElement);
    }
  },
  /**
   * @see http://vuejs.org/api/options.html#attached
   */
  attached() {
    // Provide the right order of rendering, from top to down: map.render() --> hint.render()
    // A fix for http://gitlab.element-studio.ru:8008/bower/vue-map/issues/1
    Vue.nextTick(this.render);
  }
};



// WEBPACK FOOTER //
// ./src/js/hint.js